import PropTypes from 'prop-types';
import { Box, Spinner } from '@nike/eds';
import DictionaryAlphabetCard from './dictionaryAlphabetCard';
import DictionaryAlphabetFilter from './dictionaryAlphabetFilter';
import { extendedAlphabet } from '../utils/alphabetHelpers';

export default function NikeDictionary({
  status,
  activeKey,
  data,
  dictionaryType,
  queryKey,
}: {
  status: string;
  activeKey: string;
  dictionaryType: string;
  queryKey: string;
  data: {
    char: string;
    list: DictionaryTerm[];
  }[];
}) {
  const paginationSize = data.length > 1 ? 80 : 900;
  return (
    <section className='tw-text-center tw-py-8'>
      <DictionaryAlphabetFilter
        alphabet={extendedAlphabet}
        activeKey={activeKey}
      />
      {status === 'loading' && (
        <div className='tw-h-32 tw-w-full tw-flex tw-items-center tw-justify-center'>
          <Spinner size='large' />
        </div>
      )}
      {status === 'success' && (
        <div className='tw-flex tw-flex-wrap tw-items-start tw-justify-center tw-gap-8'>
          {data.map((groupedTerms) => {
            if (groupedTerms.list.length === 0) {
              return <></>;
            }
            return (
              <Box
                key={groupedTerms.char}
                minHeight='300px'
                className='tw-px-4 tw-py-3 tw-rounded tw-border-2 tw-w-64 tw-border-slate-500 tw-bg-white'
              >
                <DictionaryAlphabetCard
                  paginationSize={paginationSize}
                  terms={groupedTerms.list}
                  label={groupedTerms.char}
                  dictionaryType={dictionaryType}
                  queryKey={queryKey}
                />
              </Box>
            );
          })}
        </div>
      )}
    </section>
  );
}

NikeDictionary.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      char: PropTypes.string,
      list: PropTypes.array,
    }),
  ),
  status: PropTypes.string,
  activeKey: PropTypes.string,
  dictionaryType: PropTypes.string,
  queryKey: PropTypes.string,
};
